module.exports = __webpack_public_path__ + "img/29.0dd68cda.png";